/**
 * 阅后即焚判定纯逻辑（14.13b；仅私聊，protocol §6.9「阅后即焚全链路」）。
 * Worker 焚烧链（session/apply）与主线程渲染（14.13c 焚烧态/禁操作）共用，
 * 判定口径不分叉。
 *
 * 口径（旧版 chat_screen 实锤）：
 * - secret 判定 = envelope 顶层 clock>0 || 行上 deleteTime 非空
 *   （_isSecretWsMessage 同口径；history 的 destroyAtTime 是旧客户端本地模型
 *   字段，不在协议里，新版不存在）。
 * - deleteTime 三种形态都要能解（_deleteTimestampSeconds 同口径）：
 *   ① 服务端 CSTLayout "2006-01-02 15:04:05"（无时区，**按 +08:00 解**——
 *   timeutil.TimestampToDateString 以 CST 格式化）；② 本地盖章的 ISO 串；
 *   ③ 纯数字秒/毫秒（>9999999999 视为毫秒）。解不出 → null（视为无焚烧标记）。
 * - clock 在所有消息类型 envelope 的**顶层**（文本/图片/语音/文件/名片同形，
 *   preview.ts build*Envelope 系列），裸文本/非 JSON → 0。
 */

/** 服务端 CSTLayout（无时区）形态 */
const CST_LAYOUT = /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2})$/;

/** envelope 顶层 clock 秒数；裸文本/非 JSON/非法值 → 0 */
export function parseEnvelopeClock(msg: string): number {
  // 先看首字符再 JSON.parse：理由同 preview.parseTextEnvelope（抛异常在热路径上
  // 很贵，本函数经 isSecretMessage 也是 buildTimelineItems 的每行每次调用）。
  // 行为等价：非 `{` 开头的串原来也都返回 0。
  if (!msg.startsWith('{')) return 0;
  let raw: unknown;
  try {
    raw = JSON.parse(msg);
  } catch {
    return 0;
  }
  if (typeof raw !== 'object' || raw === null) return 0;
  const clock = (raw as Record<string, unknown>)['clock'];
  return typeof clock === 'number' && Number.isFinite(clock) && clock > 0 ? clock : 0;
}

/** 焚烧时刻（epoch 毫秒）；空/解不出 → null */
export function parseDeleteTimeMs(raw: string | undefined): number | null {
  const text = raw?.trim() ?? '';
  if (text === '') return null;
  if (/^\d+$/.test(text)) {
    const n = Number(text);
    if (!Number.isFinite(n) || n <= 0) return null;
    return n > 9_999_999_999 ? n : n * 1000;
  }
  const cst = CST_LAYOUT.exec(text);
  const normalized = cst ? `${cst[1]}T${cst[2]}+08:00` : text;
  const ms = Date.parse(normalized);
  return Number.isFinite(ms) ? ms : null;
}

/** 阅后即焚消息判定（clock>0 或已有焚烧时刻标记） */
export function isSecretMessage(msg: string, deleteTime: string | undefined): boolean {
  return (deleteTime?.trim() ?? '') !== '' || parseEnvelopeClock(msg) > 0;
}
